module.exports = __webpack_public_path__ + "img/right_md_1.5c6074c1.jpg";